import Vue from 'vue'

const state = {
  changes: {},
  changesTotalCount: 0
}

const getters = {
  changes: (state) => {
    return state.changes
  },

  changesTotalCount: (state) => {
    return state.changesTotalCount
  },

  changesArray: (state) => {
    return Object.values(state.changes) || []
  },

  isItemChanged: (state) => (itemId) => {
    const changesArray = Object.values(state.changes) || []
    return changesArray.find(change => change.entityId === itemId)
  }
}

const actions = {
  addToChanges ({ commit, dispatch, rootState }, itemData) {
    commit('ADD_ITEM', { itemData })
  },

  removeFromChanges ({ commit, dispatch, rootState }, itemData) {
    commit('REMOVE_ITEM', { itemData })
  },

  removeAllChanges ({ commit, dispatch, rootState }) {
    commit('REMOVE_ALL_CHANGES')
  }
}

const mutations = {
  ADD_ITEM (state, { itemData }) {
    Vue.set(state.changes, itemData.changeId, itemData)
    state.changesTotalCount += 1
  },

  REMOVE_ITEM (state, { itemData }) {
    for (const key in state.changes) {
      if (key.includes(itemData.id) || key.includes(itemData.entityId)) {
        Vue.delete(state.changes, key)
        state.changesTotalCount -= 1
      }
    }
  },

  REMOVE_ALL_CHANGES (state) {
    state.changes = {}
    state.changesTotalCount = 0
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
